module.exports = __webpack_public_path__ + "static/media/mf.24f727ec.jpg";